import { RequestHandler } from 'apollo-link';

// NOTE: The following link promotes GraphQL error to network error in order for the retry link (ApolloRetryErrorLink.ts) to work.
export const graphQLErrorHandler: RequestHandler = (operation, forward) => {
  if (forward) {
    return forward(operation).map(data => {
      if (data?.errors && data.errors.length > 0) {
        data.errors.forEach(error => {
          throw new Error(error.message);
        });
      }

      return data;
    });
  }

  return null;
};
